import { OrderItem } from "src/app/core/entities/orderItem";

export function getOrderItemFromProduct(
  product: any,
  taxCalc: any,
  tax: any,
  taxValue: number,
  clientId: number,
  quantity: number,
  total: number
): OrderItem {
  let item: OrderItem = {
    cor: product.cor,
    corDescricao: product.corDescricao,
    estampa: product.estampa,
    tamanho: product.tamanho,
    cliente: clientId,
    produto: product.id,
    produtoReferencia: product.referencia,
    // produtoreferencia: product.referencia,
    produtoDescricao: product.descricao,
    quantidade: quantity,
    preco: product.precopromocional ? product.precopromocional : product.preco,
    acrescimo: 0,
    acrescimoPercent: 0,
    desconto: 0,
    descontoPercent: product.desconto,
    total: total,
    imp_estado: tax ? tax.estado : null,
    imp_ipi: tax ? tax.ipi : null,
    imp_alicms: tax ? tax.alicms : null,
    imp_alicmsorigem: tax ? tax.alicmsorigem : null,
    imp_alfcpst: tax ? tax.fcpSt : null,
    imp_substicms: tax ? tax.substicms : null,
    imp_baseipi: taxCalc ? taxCalc.base_ipi : null,
    imp_basesubst: taxCalc ? taxCalc.base_sub : null,
    imp_basefcpst: taxCalc ? taxCalc.base_fcp_st : null,
    imp_valoripi: taxCalc ? taxCalc.valor_ipi : null,
    imp_valorsubst: taxCalc ? taxCalc.valor_sub : null,
    imp_valorfcpst: taxCalc ? taxCalc.valor_fcp_st : null,
    imp_valorimposto: taxValue,
    codigoBarras: null,
  };

  return item;
}
